import { MAP_CONFIG } from './configs.js'
import { GoogleMapUtils } from './googleMap/googleMapUtils.js'
import {
  getCurrentPositionWithFallback,
} from '../utils/locationUtils.js'
import { NominatimUtils } from './nominatim/nominatimUtils.js'

export class MapUtils {
  static async getCurrentPosition(options) {
    return getCurrentPositionWithFallback(options)
  }

  static async getCurrentPositionWithFallback(options) {
    return getCurrentPositionWithFallback(options)
  }

  static async initMap(elementId, options = {}, provider = null) {
    const usedProvider = provider || MAP_CONFIG.defaultMapProvider

    switch (usedProvider) {
      case 'google':
        return GoogleMapUtils.init(elementId, options, MAP_CONFIG.googleApiKey)

      default:
        throw new Error(
          `Provider map non supporté pour initMap: ${usedProvider}`,
        )
    }
  }

  static async initFromVue(instance, provider = null) {
    const usedProvider = provider || MAP_CONFIG.defaultMapProvider

    switch (usedProvider) {
      case 'google':
        return GoogleMapUtils.initFromVue(instance)

      default:
        throw new Error(
          `Provider map non supporté pour initMap: ${usedProvider}`,
        )
    }
  }

  static detachMap(provider = null) {
    const usedProvider = provider || MAP_CONFIG.defaultMapProvider

    if (usedProvider === 'google') return GoogleMapUtils.detachMap()
    throw new Error(`Provider non supporté pour detach: ${usedProvider}`)
  }

  static destroyMap(provider = null) {
    const usedProvider = provider || MAP_CONFIG.defaultMapProvider

    if (usedProvider === 'google') return GoogleMapUtils.destroyMap()
    throw new Error(`Provider non supporté pour destroy: ${usedProvider}`)
  }

  static async getCurrentAddress(position = null, provider = null) {
    const usedProvider = provider || MAP_CONFIG.defaultGeocodeProvider

    if (usedProvider === 'google')
      return GoogleMapUtils.getCurrentAddress(position)
    if (usedProvider === 'nominatim')
      return NominatimUtils.getCurrentAddress(position)

    throw new Error(
      `Provider non supporté pour getCurrentAddress: ${usedProvider}`,
    )
  }

  static async centerOnUser(provider = null) {
    const usedProvider = provider || MAP_CONFIG.defaultMapProvider

    if (usedProvider === 'google') return GoogleMapUtils.centerOnUser()
    throw new Error(`Provider non supporté pour centerOnUser: ${usedProvider}`)
  }

  static async traceRoute(
    start,
    end,
    checkpoints = [],
    returnOnlyPath = true,
    provider = null,
  ) {
    const usedProvider = provider || MAP_CONFIG.defaultMapProvider

    if (usedProvider === 'google')
      return GoogleMapUtils.traceRoute(start, end, checkpoints, returnOnlyPath)
    throw new Error(`Provider non supporté pour traceRoute: ${usedProvider}`)
  }
}
